import AccessibilitySidebar from './core/AccessibilitySidebar';

document.addEventListener('DOMContentLoaded', () => {
  new AccessibilitySidebar();
});
